import { render, staticRenderFns } from "./drawing-package-review-new.vue?vue&type=template&id=758ed764&lang=pug&"
import script from "./drawing-package-review-new.vue?vue&type=script&lang=ts&"
export * from "./drawing-package-review-new.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports